import React from 'react';
export function ExploreIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M12 14a2 2 0 100-4 2 2 0 000 4z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.15 6.623a5 5 0 00-4.527 4.527L6 18l6.85-.623a5 5 0 004.527-4.527L18 6l-6.85.623zm4.64 1.586l-4.46.406a3 3 0 00-2.716 2.716l-.405 4.46 4.46-.406a3 3 0 002.716-2.716l.406-4.46z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-2a9 9 0 100-18 9 9 0 000 18z"
  }));
}